export default {
    namespaced: true,
    state: () => ({
        isMobile: false,
    }),

    mutations: {
        Set(state, { key, data }) {
            state[key] = data;
        },
    },
    actions: {},
};
